import { useStarterDashboardV2PageData } from 'src/app/pages/starterDashboardV2/pageContext';

export type UseDashboardEndorsements = ModelHookResult<{
	isEnabled: boolean;
}>;

export function useDashboardEndorsements(): UseDashboardEndorsements {
	const {
		data: {
			viewer: {
				experiments: {
					starterExperienceDashboardEndorsementsExperiment: { variation },
				},
			},
		},
	} = useStarterDashboardV2PageData();

	return {
		data: {
			isEnabled: variation === 'enabled',
		},
	};
}
